<template>
  <v-form v-model="isValid" class="d-flex flex-column align-center justify-center driver-form-box">
    <v-icon class="remove-driver-btn" @click="removeDriver">
      mdi-close
    </v-icon>
    <div class="driver-index">
      {{ elIndex }}
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ personalCodeQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="personalCode"
          :rules="personalCodeQuestion.rules"
          :placeholder="personalCodeQuestion.placeholder"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="mb-2 d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ nameQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="name"
          :rules="nameQuestion.rules"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row align-center">
      <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
        {{ surnameQuestion.text }}
      </v-subheader>
      <div>
        <div v-if="!isMobile" style="height: 22px;"></div>
        <v-text-field
          v-model="surname"
          :rules="surnameQuestion.rules"
          dense
          filled
          rounded
          solo
          flat
          class="text-input"
          @input="updateEvent"
        />
      </div>
    </div>
  </v-form>
</template>

<script>
import { driverQuestions } from '@/_utils/static-data';
export default {
  name: 'OneMoreDriver',
  props: {
    currentData: {
      type: Object,
      default: null
    },
    elIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      personalCode: null,
      name: null,
      surname: null,
      isValid: false
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    personalCodeQuestion() {
      return this.getQuestionById(4);
    },
    nameQuestion() {
      return this.getQuestionById(5);
    },
    surnameQuestion() {
      return this.getQuestionById(6);
    }
  },
  methods: {
    getQuestionById(id) {
      return driverQuestions(id)?.[0];
    },
    removeDriver() {
      this.personalCode = null;
      this.name = null;
      this.surname = null;
      this.$emit('removeDriver', this.currentData?.id);
    },
    updateEvent() {
      setTimeout(() => {
        this.$emit('updateData', {
          driverId: this.currentData?.id,
          data: [
            {
              question: this.personalCodeQuestion.text,
              answer: this.personalCode
            },
            {
              question: this.nameQuestion.text,
              answer: this.name
            },
            {
              question: this.surnameQuestion.text,
              answer: this.surname
            }
          ],
          isValid: this.isValid
        });
      }, 250);
    }
  }
};
</script>

<style scoped>
.driver-form-box {
  position: relative;
  padding: 5px 30px 10px 30px;
  background-color: antiquewhite;
}
.remove-driver-btn {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
}
.remove-driver-btn:hover {
  border-color: transparent;
  background: transparent;
}
.text-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input {
  border: none;
}
.driver-index {
  position: absolute;
  bottom: 6px;
  right: 18px;
  font-size: 32px;
  font-weight: 500;
  color: #FFFFFF;
}
.field-label {
  width: 180px;
}
@media screen and (max-width: 600px) {
  .field-label {
    width: 100%;
  }
  .text-input {
    width: 100%;
    min-width: 260px;
  }
  .driver-index {
    bottom: 10px;
    right: 15px;
    font-size: 38px;
  }
}
@media screen and (max-width: 400px) {
  .driver-index {
    right: 5px;
  }
}
</style>
